/**
 * Created by renatolovizotto on 12/07/17.
 */
import React, {Component} from "react";
import {inject, observer} from "mobx-react";
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import "../assets/stylesheets/DropdownFilter.scss";

@inject('Navigator', 'AuthStore', 'SchoolStore')
@observer
export default class DropdownClass extends Component {

    //value={this.props.SchoolStore.classSelected}

    /*
    ###################################
    # Change/Set CLASS -> Load LESSON #
    ###################################
    */
    handleChangeClass(classSelected) {

        /*
            calendar_id: 2329
            code: "I TT 14:00 01"
            created_at: 1505330121
            deleted_at: null
            id: 3718
            id_sf: "a1Y36000002s2cXEAQ"
            lesson_id: null
            name: "I TT 14:00 01"
            teacher_id: 1196
            unit_id: 57
            updated_at: 152814902
        */

        //Busca SchoolStore
        var SchoolStore = this.props.SchoolStore;

        //Seta Class selecionada na Store
        SchoolStore.classSelected = classSelected;

        //Zera Lesson Selecionada na Store
        SchoolStore.lessonSelected = null;

        //Limpa GroupProgress na Store
        SchoolStore.groupProgress = 0;

        //Busca Objeto Inteiro da Class
        classSelected = this.props.SchoolStore.classes[classSelected.value];

        //Seta Objeto na Store
        SchoolStore.currentClass = classSelected;

        //SchoolStore.isLoading = true;

        //Chama API
        SchoolStore.getStudentsbyClass(classSelected.id_sf);

        //Chama API
        SchoolStore.getLessonsByCLass(classSelected.id_sf);

        //SchoolStore.isLoading = false;
        this.props.SchoolStore.msgAttendance = "";
    }

    render() {

        //Options do Select de Classes
        if( this.props.SchoolStore.classes != undefined){
            var optionsClass = [];
            this.props.SchoolStore.classes.forEach(classesToOptions);
            function classesToOptions(item, index) {
                optionsClass.push({ value: index, label: item.name} );
            }
        }

        return (

            <Select
                name="class"
                options={optionsClass}
                onChange={this.handleChangeClass.bind(this)}
                placeholder="Selecione a turma"
                className="Dropdown"
                value={this.props.SchoolStore.classSelected}
            />

        );
        
    }

}


// WEBPACK FOOTER //
// ./src/containers/DropdownClass.js